import DmarcAuthSectionContainer from '../../containers/domain-progress/dmarc-auth-section-container';
import DmarcEffectivenessSectionContainer from '../../containers/domain-progress/dmarc-effectiveness-section-container';
import PropTypes from 'prop-types';
import React from 'react';

const DomainProgressReport = ( { onInitialLoad } ) => {
    return (
        <React.Fragment>
            <DmarcAuthSectionContainer onInitialLoad={onInitialLoad}  />
            <div className="page-break"></div>
            <DmarcEffectivenessSectionContainer onInitialLoad={onInitialLoad} />
        </React.Fragment>
    );
};

DomainProgressReport.propTypes = {
    classes: PropTypes.object,
    onInitialLoad: PropTypes.func
};
export default DomainProgressReport;
